import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';

import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';
import { CollectionTriggerInitialState } from '../globalSlices/collectionTriggerSlice';
import {
  getSupplierCollectionTriggers,
  createCollectionTrigger,
  updateCollectionTrigger,
  deleteCollectionTrigger,
} from '../services/collectionTriggerService';
import { CollectionTriggerWithUser } from '@dill/dill-shared';

export const getSupplierCollectionTriggersExtraReducer = (
  builder: ActionReducerMapBuilder<CollectionTriggerInitialState>
) => {
  const reducerId = 'getSupplierCollectionTriggers';
  builder.addCase(getSupplierCollectionTriggers.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getSupplierCollectionTriggers.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.triggers = action.payload.data as CollectionTriggerWithUser[];
      }
    }
  );
  builder.addCase(getSupplierCollectionTriggers.rejected, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const createCollectionTriggerExtraReducer = (
  builder: ActionReducerMapBuilder<CollectionTriggerInitialState>
) => {
  const reducerId = 'createCollectionTrigger';
  builder.addCase(createCollectionTrigger.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    createCollectionTrigger.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.triggers = [action.payload.data as CollectionTriggerWithUser, ...state.triggers];
      }
    }
  );
  builder.addCase(createCollectionTrigger.rejected, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const updateCollectionTriggerExtraReducer = (
  builder: ActionReducerMapBuilder<CollectionTriggerInitialState>
) => {
  const reducerId = 'updateCollectionTrigger';
  builder.addCase(updateCollectionTrigger.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(updateCollectionTrigger.fulfilled, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
  builder.addCase(updateCollectionTrigger.rejected, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const deleteCollectionTriggerExtraReducer = (
  builder: ActionReducerMapBuilder<CollectionTriggerInitialState>
) => {
  const reducerId = 'deleteCollectionTrigger';
  builder.addCase(deleteCollectionTrigger.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(deleteCollectionTrigger.fulfilled, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
  builder.addCase(deleteCollectionTrigger.rejected, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
